import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum AssignClientAccountRightsFormErrorStatesEnum {
    AssignRightsFailed = ErrorStateScheduleEnum.AssignClientAccountRightsFormErrorStatesStartIndex,
    CheckAlreadyAssignedRightsFailed,
    AccessRightsAlreadyAssigned
}
